export const ImageBlog = require('./image-blog.png?webp');
export { default as bg } from './bg.svg';
export { default as quotes } from './quotes.png';
